const gridCellStyle = {
  hintText: {
    fontWeight: 400,
    whiteSpace: "normal"
  }
};

export default gridCellStyle;
